(function() { window.GUID_0c82afb3_a81e_4d7c_b5f1_94dcf9d31d68 = { getGuid: function() { return "0c82afb3-a81e-4d7c-b5f1-94dcf9d31d68"; } }; })();
var CS;
(function (CS) {
    function GetKeyPressed(e) {
        let key = window.event ? e.keyCode : e.which;
        if (key == 65 && e.ctrlKey) {
            key = CS.Enums.KeyCode.CtlrA;
        }
        return key;
    }
    CS.GetKeyPressed = GetKeyPressed;
})(CS || (CS = {}));

//# sourceMappingURL=cs-keyhelper.js.map
